import React from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from './authroute'
import { ApplicationPaths } from './constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


const LoginMenu = ({ dispatch }) => {
	const logoutPath = { pathname: ApplicationPaths.LogOut, state: { local: true } }

	const resetPageLoaded = () => {
		localStorage.clear();
		sessionStorage.clear();
		dispatch({ type: "set", payload: { pageloader: { reset: Date.now() } } })
	}

	/* Hay garantía de que {user} siempre tendrá un usuario */
	return (
		<AuthContext.Consumer>
			{user => (
				<div className="dropdown user-menu">
					<Link id="dropdownAccount" to={l => l} className="text-md nav-link text-dark dropdown-toggle" data-toggle="dropdown" aria-expanded="false" aria-haspopup="true">
						<FontAwesomeIcon icon="user-circle" />
					</Link>
					<div className="dropdown-menu dropdown-menu-right pt-0" aria-labelledby="dropdownAccount" data-boundary="window">
						<div className="dropdown-item user-header text-center bg-secondary mb-2">
							<span className='d-block my-2'>{user ? user.name : 'publico'}</span>
						</div>
						{!user ? null : (
							<>
								<a className="dropdown-item" href="https://auth.iguala.do/realms/iguala/account/" target='#blank' >
									<FontAwesomeIcon icon={["fas", "user-alt"]} className="mr-1" />
									<span>Cuenta</span>
								</a>
								<div className="dropdown-divider"></div>
							</>
						)}
						<button className={`dropdown-item btn btn-link ${localStorage.length > 1 ? '' : 'disabled'}`} onClick={() => resetPageLoaded()} >
							<FontAwesomeIcon icon={["fas", "hdd"]} className="mr-1" />
							<span>Limpiar caché</span>
						</button>
						<div className="dropdown-divider"></div>
						<Link to={logoutPath} className="dropdown-item text-right user-footer" >
							<span>Salir</span>
							<FontAwesomeIcon icon={["fas", "sign-out-alt"]} className="ml-2" />
						</Link>

					</div>
				</div>

			)}
		</AuthContext.Consumer>
	)
}


export default LoginMenu
